import { saveAs } from 'file-saver';

import { appConfig } from '@config';
import { axiosInstance, callApi, handleResponse, handleError, deleteRequest } from '@helpers/api';
import { setHeaders } from '@helpers/api/setHeaders';

const createJsonUploadRequest = agent => (standardTemplate, payload) =>
  agent.post(`vFile/standardTemplateJSONUpload/${standardTemplate}/`, payload);
const listJsonUploadRequest = agent => standardTemplate =>
  agent.get(`vFile/standardTemplateJSONUpload/${standardTemplate}/`);
const getJsonUploadRowsRequest = agent => (standardTemplate, spreadsheetId) =>
  agent.get(`vFile/standardTemplateJSONUpload/${standardTemplate}/${spreadsheetId}/`);
const updateJsonUploadRequest = agent => (standardTemplate, spreadsheetId, payload) =>
  agent.put(`vFile/standardTemplateJSONUpload/${standardTemplate}/${spreadsheetId}/`, payload);

export const createSpreadsheet = async (standardTemplate, name, rows) =>
  callApi(createJsonUploadRequest)(standardTemplate, {
    name,
    list_rows: rows,
  })
    .then(handleResponse)
    .catch(handleError);

export const listSpreadsheets = async standardTemplate =>
  callApi(listJsonUploadRequest)(standardTemplate).then(handleResponse).catch(handleError);

export const getSpreadsheetRows = async (standardTemplate, spreadsheetId) =>
  callApi(getJsonUploadRowsRequest)(standardTemplate, spreadsheetId)
    .then(handleResponse)
    .catch(handleError);

export const updateSpreadsheet = async (standardTemplate, spreadsheetId, name, rows) =>
  callApi(updateJsonUploadRequest)(standardTemplate, spreadsheetId, {
    name,
    list_rows: rows,
  })
    .then(handleResponse)
    .catch(handleError);

export const downloadSpreadsheet = async (standardTemplate, spreadsheetId, filename) =>
  axiosInstance({
    method: 'GET',
    url: `${appConfig.apiUrl}/vFile/standardTemplateJSONUpload/download/${standardTemplate}/${spreadsheetId}/`,
    responseType: 'blob',
    headers: setHeaders(),
  })
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        const file = new Blob([response.data]);
        saveAs(file, `${filename}.xlsx`);
      } else {
        handleError(response);
      }
    })
    .catch(handleError);

/**
 * Deletes a spreadsheet
 * @param {string} standardTemplateId - selected standard template
 * @param {string} spreadsheetId - spreadsheet unique identifier
 * @returns {Promise<*>}
 */
export const deleteSpreadsheet = ({ standardTemplateId, spreadsheetId }) =>
  deleteRequest(`vFile/standardTemplateJSONUpload/${standardTemplateId}/${spreadsheetId}/`);
